import React from 'react';
import { motion } from 'framer-motion';

const SmsCompliance = () => {
  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-4">SMS Compliance & Policy</h1>
          <p className="text-slate-500 mb-10 pb-6 border-b border-slate-100">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <div className="space-y-8 text-slate-600 leading-relaxed font-light">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Program Description</h2>
              <p>
                Toptier Ventures utilizes SMS text messaging to communicate with landowners who have explicitly opted in to receive communications. Messages may include property cash offers, transaction updates, requests for property details, and general support regarding your file.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Opt-In & Consent</h2>
              <p>
                By providing your phone number and checking the explicit SMS consent box on our web forms, you agree to receive text messages from Toptier Ventures. Consent is not a condition of purchase.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Message and Data Rates</h2>
              <p className="font-medium text-slate-800">
                Message and data rates may apply for any messages sent to you from us and to us from you. Message frequency varies based on your interaction with our team.
              </p>
            </section>

            <section className="bg-slate-50 p-6 rounded-2xl border border-slate-200">
              <h2 className="text-xl font-bold text-slate-900 mb-4">4. Opt-Out (STOP) Instructions</h2>
              <p>
                You can cancel the SMS service at any time. Just text <strong>"STOP"</strong> to the shortcode or number that messaged you. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time.
              </p>
            </section>

            <section className="bg-slate-50 p-6 rounded-2xl border border-slate-200">
              <h2 className="text-xl font-bold text-slate-900 mb-4">5. Help Instructions</h2>
              <p>
                If you are experiencing issues with the messaging program you can reply with the keyword <strong>"HELP"</strong> for more assistance, or you can get help directly at <strong>251-235-2120</strong>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Carrier Liability</h2>
              <p>
                Carriers are not liable for delayed or undelivered messages. If you have questions about your text plan or data plan, please contact your wireless provider.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Privacy of Mobile Data</h2>
              <p className="font-medium text-slate-800">
                We respect your privacy. We will not share or sell your mobile number or SMS consent to any third parties, affiliates, or partners for marketing or promotional purposes.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SmsCompliance;